/* import __COLOCATED_TEMPLATE__ from './delete-button.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let DeleteButton = (_class = class DeleteButton extends Component {
  get isVisible() {
    let {
      selectionIsHtml
    } = this.args.composer.state;
    return selectionIsHtml;
  }
  get clippingElement() {
    let elements = document.getElementsByClassName(
    // eslint-disable-next-line @intercom/intercom/no-bare-strings
    'embercom-prosemirror-composer-html-block embercom-prosemirror-composer-block-selected ProseMirror-selectednode');
    return elements.length > 0 ? elements[0].closest(this.args.options?.clippingParentClass) : undefined;
  }
  deleteHtml() {
    this.args.composer.commands.deleteSelection();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "deleteHtml", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteHtml"), _class.prototype)), _class);
export { DeleteButton as default };